<template>
  <div class="app-container">
    <div class="stickyheader">
       <TrialMessage  />
      <AppHeader class="appheader"></AppHeader>
    </div>
    <slot />
  </div>
</template>


<script setup lang="ts">
import AppHeader from '@/components/AppHeader.vue';
import { useMeStore } from '@/stores/me';
import { storeToRefs } from 'pinia';
import TrialMessage from '@/components/Subscription/TrialMessage.vue';

const me_store = useMeStore();
const { me } = storeToRefs(me_store);
</script>

<style scoped lang="scss">
.app-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
  overflow: auto;
}

.appheader {
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    z-index: -1;
  }

  
}

.stickyheader {
  position: sticky;
  top: 0;
  z-index: 10;
}
</style>